/** Sentinel for the "Your AI Agents" pill (agents with no category). */
export const MINE = "Your AI Agents";

const sameName = (a, b) =>
  Boolean(a) &&
  Boolean(b) &&
  String(a).trim().toLowerCase() === String(b).trim().toLowerCase();

/**
 * Does an agent belong to the selected category pill?
 *
 * `filter` is null for "All AI Agents", MINE for uncategorised agents, or an
 * agency category object otherwise.
 *
 * An agent stores a snapshot of the category it was created with, so its `id`
 * can drift from the agency's current Categories — the backend regenerates
 * those ids every time default settings are applied
 * (backend/src/routes/agency/services.js, applyDefaultSettings). Matching on id
 * alone silently returned nothing for agents created before the last
 * regeneration, so the name (what the card actually shows) is the fallback.
 */
export const matchesCategory = (agent, filter) => {
  if (!filter) return true;
  const categories = agent?.category || [];
  if (filter === MINE) return categories.length === 0;
  return categories.some(
    (item) =>
      (item?.id && filter?.id && String(item.id) === String(filter.id)) ||
      sameName(item?.name, filter?.name)
  );
};
